import cuteMonsters from '../img/cute-monsters.png';

const sprite = new Image();
sprite.src = cuteMonsters;

const scale = 0.14;
const spriteSheetWidth = 2172 * scale;
const spriteSheetHeight = 724 * scale;
const spriteSheetColumns = 3;
const spriteSheetRows = 1;
const frameWidth = spriteSheetWidth / spriteSheetColumns;
const frameHeight = spriteSheetHeight / spriteSheetRows;
const frameY = 0;

function getRandomSpriteSheet() {
    return sprite;
}

function getBackgroundSize() {
    return `${spriteSheetWidth}px ${spriteSheetHeight}px`;
}

function createEnemySpriteSheet() {
    let timeSinceLastFrame = 0;
    const frameX = Math.floor(Math.random() * spriteSheetColumns);

    function getBackgroundPosition() {
        return `-${frameWidth * frameX}px -${frameHeight * frameY}px`;
    }

    function update(deltaTime) {
        timeSinceLastFrame += deltaTime;
        timeSinceLastFrame += deltaTime;
        if (timeSinceLastFrame > 1000) timeSinceLastFrame = 0;
    }

    return {
        sprite: getRandomSpriteSheet(),
        frameWidth,
        frameHeight,
        getRandomSpriteSheet,
        getBackgroundPosition,
        getBackgroundSize,
        update,
    };
}

export default createEnemySpriteSheet;
